import { ErrorHandler, Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { LoggerService } from '../services/utils/logger.service';
import { LogLevels } from '../types/enums';
import { httpErrorLogLevel } from './http-error-log-level';

const MAX_VALUE_LENGTH = 1000;

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  constructor(private logger: LoggerService) {}

  handleError(error: unknown): void {
    if (error instanceof HttpErrorResponse) {
      this.logger.log('Unhandled HTTP error', httpErrorLogLevel(error.status), {
        source: 'runtime',
        status: error.status,
        statusText: error.statusText,
        url: error.url,
      });
    } else if (error instanceof Error) {
      this.logger.log(error.message, LogLevels.error, {
        source: 'runtime',
        name: error.name,
        stack: error.stack,
      });
    } else if (typeof error === 'string') {
      this.logger.log(error, LogLevels.error, { source: 'runtime' });
    } else {
      const type = this.typeOf(error);
      this.logger.log(`Non-Error value thrown: ${type}`, LogLevels.error, {
        source: 'runtime',
        type,
        value: this.serialise(error),
      });
    }

    console.error(error);
  }

  private typeOf(value: unknown): string {
    if (value === null) return 'null';
    if (typeof value !== 'object') return typeof value;
    return value.constructor?.name || 'Object';
  }

  private serialise(value: unknown): string {
    let serialised: string | undefined;
    try {
      serialised = JSON.stringify(value);
    } catch {
      serialised = undefined;
    }
    return (serialised ?? String(value)).slice(0, MAX_VALUE_LENGTH);
  }
}
